import React from 'react';

import { ExperimentName, EXPERIMENTS } from 'utils/constants/experiment-configs';
import { useExperiment } from 'utils/customHooks/useExperiment';

import { LockIconWrapper, SecurityTextContent, SecurityTextWrapper, StyledIconLock } from './SecurityBadgesText-styled-components';

export const SecurityBadgesText = () => {
  const { isVariant } = useExperiment({
    experiment: EXPERIMENTS[ExperimentName.CHECKOUT_SECURITY_MESSAGING],
  });

  if (!isVariant) {
    return null;
  }

  return (
    <SecurityTextWrapper>
      <LockIconWrapper>
        <StyledIconLock />
      </LockIconWrapper>
      <SecurityTextContent>
        Your information is encrypted and used only to match your appointment and verify coverage.
      </SecurityTextContent>
    </SecurityTextWrapper>
  );
};
